import React from 'react';
import TieupSizePanel from './components/TieupSizePanel'
import TieupGrid from './components/TieupGrid'
import SearchButton from './components/SearchButton'
import PrimaryButton from '../../components/PrimaryButton'
import ProgressBar from './components/ProgressBar'
import FileUpload from './components/FileUpload'
import SizeSelector from './components/SizeSelector'
import CopyrightNotice from './components/CopyrightNotice'

class TreadleReducer extends React.Component {

    constructor() {
        super()
        this.state = {
            currentState: 'initial',
            tieupShaftsCount: 2,
            tieupTreadlesCount: 2,
            targetTreadlesCount: 2,
            tieupArray: this.buildTieupArray(2, 2),
            percentComplete: 0
        }
    }

    setDisplayState(newState) {
        this.setState((previousState) => { return { currentState: newState } })
    }

    setTieupArrayState(shaftsCount, treadlesCount) {
        let tieupArray = this.buildTieupArray(shaftsCount, treadlesCount)
        this.setState((previousState) => { return { tieupArray: tieupArray } })
    }

    buildTieupArray(shaftsCount, treadlesCount) {
        let tieupArray = new Array(shaftsCount)
        for (let i = 0; i < shaftsCount; i++) {
            let shaftTreadlesArray = new Array(treadlesCount)
            tieupArray[i] = shaftTreadlesArray
        }
        return tieupArray
    }

    buildTreadlingReplacementsDisplayItems(treadlingReplacements) {
        let displayLines = []

        for (let originalTreadleNumber in Object.getOwnPropertyNames(treadlingReplacements)) {
            let displayTreadleNumber = parseInt(originalTreadleNumber, 10) + 1

            let originalTreadleDiv =
                <div className='reducer-treadling-replacements-cell'>
                    {displayTreadleNumber.toString(10)}
                </div>

            let replacementsForTreadle = treadlingReplacements[originalTreadleNumber]
            let replacementsText = ''

            for (let i = 0; i < replacementsForTreadle.length; i++) {
                if (i > 0) {
                    replacementsText += ", "
                }
                let replacementTreadleNumber = replacementsForTreadle[i] + 1
                replacementsText += ' ' + replacementTreadleNumber.toString(10)
            }

            let replacementTreadlesDiv =
                <div className='reducer-treadling-replacements-cell'>
                    {replacementsText}
                </div>

            let displayLine =

                <div key={originalTreadleNumber} className='reducer-treadling-replacements-row'>
                    {originalTreadleDiv}{replacementTreadlesDiv}
                </div>

            displayLines.push(displayLine)
        }
        return displayLines
    }

    handleManualInputChooseSize(e) {
        this.setDisplayState('chooseTieupSize')
    }

    handleTieupGridInput(e) {
        this.setDisplayState('manualTieupInput')
    }

    handleWIFUploaded(newWIFTieupArray, shaftsCount, treadlesCount) {
        this.setState((previousState) => { return { tieupArray: newWIFTieupArray } })
        this.setState((previousState) => { return { tieupShaftsCount: shaftsCount } })
        this.setState((previousState) => { return { tieupTreadlesCount: treadlesCount } })
        this.handleSetDefaultTargetTreadlesFromShaftsCount(shaftsCount, treadlesCount)
        this.setDisplayState('WIFUploaded')
    }

    handleStartOver(e) {
        this.setDisplayState('initial')
        this.setState((previousState) => { return { tieupShaftsCount: 2, tieupTreadlesCount: 2, tieupArray: this.buildTieupArray(2, 2) } })
    }

    handleTieupShaftsSelected(e) {
        let theValue = e.target.value
        let newShaftsCount = parseInt(theValue, 10)
        this.setTieupArrayState(newShaftsCount, this.state.tieupTreadlesCount)
        this.setState((previousState) => { return { tieupShaftsCount: newShaftsCount } })
        this.handleSetDefaultTargetTreadlesFromShaftsCount(newShaftsCount, this.state.tieupTreadlesCount)
    }


    handleSetDefaultTargetTreadlesFromShaftsCount(shaftsCount, treadlesCount) {
        let newTargetTreadlesValue = shaftsCount + 2
        if (newTargetTreadlesValue > 40) {
            newTargetTreadlesValue = 40
        }

        if (newTargetTreadlesValue >= treadlesCount) {
            newTargetTreadlesValue = treadlesCount - 1
        }

        let targetTreadles = {
            target: {
                value: newTargetTreadlesValue
            }
        }
        this.handleTargetTreadlesSelected(targetTreadles)
    }

    handleTieupTreadlesSelected(e) {
        let theValue = e.target.value
        let newTreadlesCount = parseInt(theValue, 10)
        this.setTieupArrayState(this.state.tieupShaftsCount, newTreadlesCount)
        this.setState((previousState) => { return { tieupTreadlesCount: newTreadlesCount } })
        this.handleSetDefaultTargetTreadlesFromShaftsCount(this.state.tieupShaftsCount, newTreadlesCount)
    }

    handleTargetTreadlesSelected(e) {
        let theValue = e.target.value
        let newTreadlesCount = parseInt(theValue, 10)
        this.setState((previousState) => { return { targetTreadlesCount: newTreadlesCount } })
    }

    handleProgressUpdate(currentPercentComplete) {
        if (this.state.currentState !== 'searching') {
            this.setDisplayState('searching')
        }
        this.setState((previousState) => { return { percentComplete: currentPercentComplete } })
    }

    handleToggleTieupCell(shaft, treadle) {
        let newTieupArray = this.state.tieupArray.slice()
        let previousValue = false;
        if (newTieupArray[shaft][treadle]) {
            previousValue = true
        }
        newTieupArray[shaft][treadle] = !previousValue
        this.setState((previousState) => { return { tieupArray: newTieupArray } })
    }

    handleFinalResults(skeletonTieupArray, resultsTreadlingReplacementsMap) {
        this.setState((previousState) => { return { resultsTieupArray: skeletonTieupArray, resultsTreadlingReplacementsMap: resultsTreadlingReplacementsMap } })
        if (skeletonTieupArray && skeletonTieupArray.length > 0) {
            this.setDisplayState('resultsFound')
        }
        else {
            this.setDisplayState('resultsNotFound')
        }

    }

    render() {

        let buttonsPanel = null
        let tieupSizePanel = null
        let tieupGrid = null
        let fileUpload = null
        let searchButton = null
        let enterTieupPrompt = null
        let WIFEnterLoomTreadlesCountDropdown = null
        let progressDisplay = null
        let skeletonTieupDisplay = null
        let treadlingReplacementsDisplay = null


        if (this.state.currentState === 'initial') {

            buttonsPanel =
                <div>
                    <div className='reducer-medium-padding-top'>
                        <h2>Would you like to enter the original tieup here or upload a WIF?</h2>
                    </div>
                    <div className='reducer-small-padding-top reducer-inline'>
                        <PrimaryButton onClick={(e) => this.handleManualInputChooseSize(e)}>Enter Tieup Manually</PrimaryButton>&nbsp;&nbsp;
                </div>
                    <div className='smalladdingTop reducer-inline reducer-small-margin-top'>
                        <FileUpload WIFUploadedHandler={(newTieupArray, shaftsCount, treadlesCount) => { this.handleWIFUploaded(newTieupArray, shaftsCount, treadlesCount) }} />
                    </div>
                </div>
        }

        if (this.state.currentState === 'chooseTieupSize') {
            tieupSizePanel =
                <div className='reducer-medium-padding-top reducer-medium-line-height'>
                    <TieupSizePanel
                        prompt='Enter the original tieup size and the number of treadles on your loom: '
                        tieupShaftsChangedFunction={(e) => this.handleTieupShaftsSelected(e)}
                        tieupTreadlesChangedFunction={(e) => this.handleTieupTreadlesSelected(e)}
                    />&nbsp;&nbsp;&nbsp;
                    <PrimaryButton onClick={(e) => this.handleTieupGridInput(e)}>Enter Tieup</PrimaryButton>
                </div>
        }

        if (this.state.currentState === 'manualTieupInput') {
            tieupGrid = <TieupGrid
                tieupDataArray={this.state.tieupArray}
                treadlesCount={this.state.tieupTreadlesCount}
                shaftsCount={this.state.tieupShaftsCount}
                toggleGridCellFunction={(shaft, treadle) => this.handleToggleTieupCell(shaft, treadle)}
            />
            enterTieupPrompt = <div className='reducer-small-padding-top'><h2>Click to enter your tieup:</h2></div>
        }

        if (this.state.currentState === 'WIFUploaded') {
            tieupGrid = <TieupGrid
                tieupDataArray={this.state.tieupArray}
                treadlesCount={this.state.tieupTreadlesCount}
                shaftsCount={this.state.tieupShaftsCount}
            />
            enterTieupPrompt = <div className='reducer-small-padding-top'><h2>Tieup from WIF</h2></div>
        }

        if (this.state.currentState === 'WIFUploaded' || this.state.currentState === 'manualTieupInput') {
            WIFEnterLoomTreadlesCountDropdown =
                <div className='reducer-medium-padding-top reducer-inline reducer-medium-bottom-margin'>
                    <SizeSelector currentValue={this.state.targetTreadlesCount} onChangeFunction={(e) => this.handleTargetTreadlesSelected(e)} prompt='Treadles&nbsp;on&nbsp;Your&nbsp;Loom:&nbsp;' />
                </div>
        }

        if (this.state.currentState === 'manualTieupInput' || this.state.currentState === 'WIFUploaded' || this.state.currentState === 'searching') {

            let styleValue = {}

            if (this.state.currentState === 'manualTieupInput') {
                styleValue = { display: 'inline' }
            }
            else if (this.state.currentState === 'WIFUploaded') {
                styleValue = { display: 'inline' }
            }
            else if (this.state.currentState === 'searching') {
                styleValue = { display: 'none' }
            }

            searchButton =
                <div className='reducer-medium-padding-top' style={styleValue}>
                    <SearchButton
                        baseLambdaUri = {this.props.baseLambdaUri}
                        baseS3Uri = {this.props.baseS3Uri}
                        apiKey = {this.props.apiKey}
                        tieupArray={this.state.tieupArray}
                        targetTreadlesCount={this.state.targetTreadlesCount}
                        resultsHandler={(skeletonTieupArray, treadlingReplacements) => this.handleFinalResults(skeletonTieupArray, treadlingReplacements)}
                        progressUpdateHandler={(newPercentComplete) => { this.handleProgressUpdate(newPercentComplete) }}
                    />
                </div>
        }


        if (this.state.currentState === 'searching') {
            progressDisplay =
                <div className='reducer-medium-padding-top'>
                    <h2>Looking for a Skeleton Tieup...</h2>
                    <ProgressBar percentComplete={this.state.percentComplete} />
                </div>

            tieupGrid =
                <div className='reducer-medium-padding-top reducer-inline-top'>
                    <h2>Original Tieup:</h2>
                    <TieupGrid
                        tieupDataArray={this.state.tieupArray}
                        treadlesCount={this.state.tieupTreadlesCount}
                        shaftsCount={this.state.tieupShaftsCount}
                    />
                </div>

        }

        if (this.state.currentState === 'resultsFound' || this.state.currentState === 'resultsNotFound') {
            tieupGrid =
                <div className='reducer-medium-padding-top reducer-inline-top reducer-medium-padding-left'>
                    <h2>Original Tieup</h2>
                    <TieupGrid
                        tieupDataArray={this.state.tieupArray}
                        treadlesCount={this.state.tieupTreadlesCount}
                        shaftsCount={this.state.tieupShaftsCount}
                    />
                </div>

            if (this.state.currentState === 'resultsFound') {

                let treadlingReplacementsDisplayItems = this.buildTreadlingReplacementsDisplayItems(this.state.resultsTreadlingReplacementsMap)

                skeletonTieupDisplay =
                    <div className='reducer-medium-padding-top reducer-inline-top reducer-medium-padding-left'>
                        <h2>Skeleton Tieup</h2>
                        <TieupGrid
                            tieupDataArray={this.state.resultsTieupArray}
                            treadlesCount={this.state.resultsTieupArray[0].length}
                            shaftsCount={this.state.resultsTieupArray.length}
                            toggleGridCellFunction={null}
                        />
                    </div>
                treadlingReplacementsDisplay =
                    <div className='reducer-medium-padding-top reducer-inline-top reducer-medium-padding-left'>
                        <h2>Treadling</h2>

                        <div className='reducer-treadling-replacements-grid reducer-medium-padding-top'>
                            <div className='reducer-treadling-replacements-row reducer-small-padding-top'>
                                <div className='reducer-treadling-replacements-cell'>
                                    Original
                                </div>
                                <div className='reducer-treadling-replacements-cell'>
                                    Skeleton
                                </div>
                            </div>
                            {treadlingReplacementsDisplayItems}
                        </div>
                    </div>
            }
            else {
                skeletonTieupDisplay =
                    <div className='reducer-medium-padding-top reducer-medium-padding-left'>
                        <h2>Sorry, no skeleton tieup could be found.</h2>
                    </div>

                treadlingReplacementsDisplay = null
            }
        }


        return (
            <div className='reducer-medium-padding-top'>
                <div>
                    <div style={{ width: '50%' }} className='reducer-inline'>
                        <h1>Skeleton Tieup Search</h1>
                    </div>
                    <div style={{ width: '50%' }} className='reducer-inline reducer-right'>
                        <PrimaryButton onClick={(e) => this.handleStartOver(e)}>Start Over</PrimaryButton>
                    </div>
                </div>
                <p>
                    A skeleton tieup reduces the number of treadles required to weave a draft by sometimes using more than one treadle at once.  Not every draft has a skeleton tieup that can be found in a finite amount of time. When one can be
                    located, sometimes a loom lacking enough treadles for the original tieup can still weave the same pattern.
                 </p>
                <p>                    
                    This page will search for a skeleton tieup for rising shed looms, displaying the first one found which works on your loom or the best one found within five minutes.  
                </p>
                {buttonsPanel}
                {tieupSizePanel}
                {fileUpload}
                {enterTieupPrompt}
                {progressDisplay}
                {tieupGrid}
                {WIFEnterLoomTreadlesCountDropdown}
                {searchButton}
   
                {skeletonTieupDisplay}
                {treadlingReplacementsDisplay}
                <hr />
                <div className='reducer-small-padding-top'>
                    <div style={{ width: '30%', maxWidth: '183px' }} className='reducer-inline-top'>
                        <img style={{ width: '100%' }} src='https://cdn.handweaving.net/site/Pages/SwiftSmall.jpg' alt='old swift' />
                    </div>
                    <div style={{ width: '70%' }} className='reducer-inline-top reducer-medium-padding-left'>
                        <h1>About Handweaving.net</h1>
                        <p>
                        <a href='https://www.handweaving.net'>Handweaving.net</a> is a digital weaving archive offering large online collections of historic drafts, weaving and textiles documents, and more.
                        </p>
                        <p>
                            Much of the site is free to use and for just $20.00 USD per year you can also view, print, and download over 65,000 full weaving
                            drafts including many from old historic sources.
                        </p>
                        <div className='reducer-medium-padding-top'>
                            <a className='btn btn-primary' href='https://www.handweaving.net'>Explore Handweaving.net</a>
                        </div>
                    </div>
                </div>
                <CopyrightNotice />
            </div>
        )
    }
}

export default TreadleReducer



// WEBPACK FOOTER //
// ./src/scenes/reducer/index.js